var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeeignetFuerOelabschneider = function SvgGeeignetFuerOelabschneider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Geeignet_fuer_Oelabschneider_svg__Ebene_2",
    viewBox: "0 0 83.89 100.53"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Geeignet_fuer_Oelabschneider_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.9px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Geeignet_fuer_Oelabschneider_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.16 1.45h59.57c5.91 0 10.71 4.8 10.71 10.71v86.92H1.45V12.16c0-5.91 4.8-10.71 10.71-10.71Z",
    className: "Geeignet_fuer_Oelabschneider_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.95,
    cy: 51.23,
    r: 23.66,
    className: "Geeignet_fuer_Oelabschneider_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.95,
    cy: 38.65,
    r: 23.66,
    className: "Geeignet_fuer_Oelabschneider_svg__cls-1"
  }))));
};
export default SvgGeeignetFuerOelabschneider;